import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* eslint-disable no-undef */
// TODO update eslint packages to remove this error


import apiHelper from '@appfolio/js-api-helper';

var ApiHelper = function ApiHelper() {
  var _this = this;

  _classCallCheck(this, ApiHelper);

  this.getCsrfToken = function () {
    var meta = document.querySelector('meta[name="csrf-token"]');
    return meta ? meta.getAttribute('content') : '';
  };

  this.jwtStorage = 'jwt';
  this.jwt = void 0;

  this.generateAuthHeader = function (token) {
    return "Bearer ".concat(token);
  };

  this.baseUrl = void 0;

  this.pathHelper = function (path) {
    if (_this.baseUrl) {
      return new URL(path, _this.baseUrl).href;
    }

    return path;
  };

  this.getFormattedJwtToken = function () {
    if (_this.jwt) return _this.generateAuthHeader(_this.jwt);
    if (!_this.jwtStorage) return null;
    var token = window.localStorage.getItem(_this.jwtStorage);
    if (!token) return '';
    return _this.generateAuthHeader(token);
  };

  this.saveJwtTokenFromHeader = function (headers) {
    if (!_this.jwtStorage) return;
    var jwtHeader = headers.get('X-JWT');
    if (jwtHeader) window.localStorage.setItem(_this.jwtStorage, jwtHeader);
  };

  this.serialize = function (obj, options) {
    return apiHelper.serialize(obj, options);
  };

  this.get = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(path, params) {
      var options,
          headers,
          newOptions,
          response,
          _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 2 && _args[2] !== undefined ? _args[2] : {
                convertCase: true,
                // deprecated
                convertResponseCase: true,
                convertRequestCase: true,
                serializeOptions: {}
              };
              headers = _objectSpread({
                Authorization: _this.getFormattedJwtToken()
              }, options.headers);
              newOptions = _objectSpread(_objectSpread({}, options), {}, {
                headers: headers
              });
              _context.next = 5;
              return apiHelper.get(_this.pathHelper(path), params, newOptions);

            case 5:
              response = _context.sent;

              _this.saveJwtTokenFromHeader(response.response.headers);

              return _context.abrupt("return", response.data);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  this.post = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(path, body) {
      var options,
          headers,
          newOptions,
          response,
          _args2 = arguments;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              options = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {
                convertCase: true,
                // deprecated
                convertResponseCase: true,
                convertRequestCase: true
              };
              headers = _objectSpread({
                'X-CSRF-Token': _this.getCsrfToken(),
                Authorization: _this.getFormattedJwtToken()
              }, options.headers);
              newOptions = _objectSpread(_objectSpread({}, options), {}, {
                headers: headers
              });
              _context2.next = 5;
              return apiHelper.post(_this.pathHelper(path), body, newOptions);

            case 5:
              response = _context2.sent;

              _this.saveJwtTokenFromHeader(response.response.headers);

              return _context2.abrupt("return", response.data);

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();

  this.put = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(path, body) {
      var options,
          headers,
          newOptions,
          response,
          _args3 = arguments;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              options = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : {
                convertCase: true,
                // deprecated
                convertResponseCase: true,
                convertRequestCase: true
              };
              headers = _objectSpread({
                'X-CSRF-Token': _this.getCsrfToken(),
                Authorization: _this.getFormattedJwtToken()
              }, options.headers);
              newOptions = _objectSpread(_objectSpread({}, options), {}, {
                headers: headers
              });
              _context3.next = 5;
              return apiHelper.put(_this.pathHelper(path), body, newOptions);

            case 5:
              response = _context3.sent;

              _this.saveJwtTokenFromHeader(response.response.headers);

              return _context3.abrupt("return", response.data);

            case 8:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }();

  this.del = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(path, body) {
      var options,
          headers,
          newOptions,
          response,
          _args4 = arguments;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              options = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : {
                convertCase: true,
                convertResponseCase: true,
                convertRequestCase: true
              };
              headers = _objectSpread({
                'X-CSRF-Token': _this.getCsrfToken(),
                Authorization: _this.getFormattedJwtToken()
              }, options.headers);
              newOptions = _objectSpread(_objectSpread({}, options), {}, {
                headers: headers
              });
              _context4.next = 5;
              return apiHelper.del(_this.pathHelper(path), body, newOptions);

            case 5:
              response = _context4.sent;

              _this.saveJwtTokenFromHeader(response.response.headers);

              return _context4.abrupt("return", response.data);

            case 8:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x7, _x8) {
      return _ref4.apply(this, arguments);
    };
  }();

  this.patch = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(path, body) {
      var options,
          headers,
          newOptions,
          response,
          _args5 = arguments;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              options = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : {
                convertCase: true,
                // deprecated
                convertResponseCase: true,
                convertRequestCase: true
              };
              headers = _objectSpread({
                'X-CSRF-Token': _this.getCsrfToken(),
                Authorization: _this.getFormattedJwtToken()
              }, options.headers);
              newOptions = _objectSpread(_objectSpread({}, options), {}, {
                headers: headers
              });
              _context5.next = 5;
              return apiHelper.patch(_this.pathHelper(path), body, newOptions);

            case 5:
              response = _context5.sent;

              _this.saveJwtTokenFromHeader(response.response.headers);

              return _context5.abrupt("return", response.data);

            case 8:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x9, _x10) {
      return _ref5.apply(this, arguments);
    };
  }();
};

var api = new ApiHelper();
export default api;